import React, { useEffect, useRef, useState } from "react";
import {
  arrow_icon,
  delete_icon,
  dummyimage,
  edit_icon,
  Search_icon,
  view_icon,
} from "../../assets/img";
import { useNavigate } from "react-router-dom";
import CommonMuiTable, { Table } from "../../components/Table/Table";
import { admin_list, Amenities_list } from "../redux/api/dummyJson";
import Topbar from "../../components/Topbar/Topbar";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import { checkPermission } from "../redux/api/PermissionManager";

const TermsAndCondition = () => {
  const [page, setPage] = useState(1);
  const [superAdmin, setSuperAdmin] = useState();
  const [pagination, setPagination] = useState("");
  const [tagLine, setTagLine] = useState("");
  const [loader, setLoader] = useState(false);
  const [popup, setPopup] = useState(false);
  const [addPopup, setAddPopup] = useState(false);
  const [type, setType] = useState();
  const [errors, setErrors] = useState(false);
  const [policy, setPolicy] = useState("");
  const [names, setNames] = useState([]);
  const [search, setSearch] = useState("");
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState();

  const fetch = async (page = 1) => {
    const url = search
      ? `${URLS.MASTERURL}?type=${15}&search=${search}`
      : `${URLS.MASTERURL}?type=${15}&page=${page}`;

    get(url)
      .then((res) => {
        toast.success(res?.message);
        console.log("res tags list", res);
        setOwners(res?.data || []);
        setTotalCount(res?.count);
        // Assuming your API paginates with 10 items per page
        const pageSize = 10;
        const lastPage = Math.ceil(res?.count / pageSize);

        setPagination({
          current_page: page,
          last_page: lastPage,
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const fetchView = async (id) => {
    try {
      const res = await get(`${URLS.MASTERURL}${id}/`);
      setTagLine(res?.data?.name);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetch(page);
    if (editId) fetchView(editId);
  }, [search, page, editId]);

  const handleSubmit = async () => {
    if (names.length !== 0) {
      // Normalize to lowercase for comparison
      const existingNames = names?.filter((n) =>
        owners.some((item) => item.name.toLowerCase() === n.toLowerCase())
      );

      if (existingNames?.length > 0) {
        toast.error(`Already exists: ${existingNames.join(", ")}`);
        return; // stop here, don't call API
      }

      // 2. Check for duplicates inside names itself (case-insensitive)
      const lowerCaseNames = names.map((n) => n.toLowerCase());
      const duplicateNames = names.filter(
        (n, i) => lowerCaseNames.indexOf(n.toLowerCase()) !== i
      );

      if (duplicateNames.length > 0) {
        toast.error(`Duplicates inside names: ${duplicateNames.join(", ")}`);
        return;
      }
    }

    if (type == "add") {
      if (names?.length == 0) {
        setErrors(true);
      } else {
        if (policy.trim() !== "") {
          toast.error("Please add entered data");
          return;
        }
        setLoading(true);
        setAddPopup(false);
        const formdata = new FormData();
        formdata.append("type", 15);
        formdata.append("name", names);
        formdata.append("status", true);
        try {
          const res = await post(`${URLS.MASTERURL}add/`, formdata);
          console.log("res post room category", res);
          if (res.status === "success") {
            toast.success(res.message || "Added successfully");
          }
          setNames([]);
          fetch(page);
          setLoading(false);
        } catch (err) {
          console.error(err);
          setLoading(false);
        } finally {
          setLoading(false);
        }
      }
    }
    if (type == "edit") {
      if (!tagLine) {
        toast.error("Please enter TagLine");
        setErrors(true);
      } else {
        setAddPopup(false);
        setLoading(true);
        const formdata = new FormData();
        formdata.append("type", 15);
        formdata.append("name", tagLine);

        try {
          const res = await post(`${URLS.MASTERURL}${editId}/edit/`, formdata);
          console.log("res edit room category", res);
          if (res.status === "success") {
            toast.success("Edited successfully");
          }
          setNames([]);
          fetch(page);
          setLoading(false);
        } catch (err) {
          console.error(err);
          setLoading(false);
        } finally {
          setLoading(false);
        }
      }
    }
  };

  const [owners, setOwners] = useState([]);

  // ✅ Toggle status
  const handleStatus = async ({ id, status }) => {
    const formdata = new FormData();
    formdata.append("status", !status);
    setLoading(true);
    try {
      const res = await post(`${URLS.MASTERURL}${id}/status/`, formdata);
      if (res?.status === "success") {
        toast.success(res?.message || "Status updated");
        fetch(page);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error updating status:", error);
      setLoading(false);
      toast.error("Failed to update status");
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    e.preventDefault();
    console.log("event", policy);
    if (policy.trim() !== "") {
      setNames([...names, policy.trim()]);
      setPolicy("");
      setErrors("");
    }
  };
  const handleDelete = (index) => {
    setNames((prev) => prev.filter((_, i) => i !== index));
  };

  const handleDeleteList = async () => {
    setLoading(true);
    if (editId) {
      try {
        const res = await post(`${URLS.MASTERURL}${editId}/delete/`);
        console.log("res delete category", res);
        if (res?.status === "success") {
          toast.success(res?.message);
        }
        setPopup(false);
        fetch(page);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "S.No",
        Cell: ({ row }) => {
          const pageSize = 10;
          return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
        },
      },
      {
        Header: "Term & Coditions",
        accessor: "name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },

      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  if (checkPermission("CAN-STATUS-TERMS_&_CONDITIONS"))
                    handleStatus(row.original);
                }}
                className={`${
                  value == false ? "deactive-btn" : "active-btn"
                } border-0  fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13 fs-xxl-18`}
              >
                {value == false ? "De-active" : " Active"}
              </button>
            </div>
          );
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-js gap-3">
                {checkPermission("CAN-EDIT-TERMS_&_CONDITIONS") && (
                  <button
                    onClick={() => {
                      setAddPopup(true);
                      setType("edit");
                      setEditId(row.original.id);
                      fetchView(row.original.id);
                    }}
                    className="cust-btn "
                  >
                    <img src={edit_icon} alt="" className=" edit-btn " />
                  </button>
                )}
                {checkPermission("CAN-DELETE-TERMS_&_CONDITIONS") && (
                  <button
                    onClick={() => {
                      setPopup(true);
                      setEditId(row.original.id);
                    }}
                    // onClick={() => setDeletePopup(row.original.id)}
                    className="cust-btn "
                  >
                    <img src={delete_icon} alt="" className=" edit-btn " />
                  </button>
                )}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [page]
  );

  return (
    <div>
      <Topbar header={"Master"} subHead={"Terms & Condition"} />
      <div className="d-flex ac-jb">
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
          Total: {totalCount || owners?.length}
        </h2>
        <div className="d-flex gap-3">
          <div className="search-input">
            <input
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
            />
            <img src={Search_icon} className="search" />
          </div>
          {checkPermission("CAN-ADD-TERMS_&_CONDITIONS") && (
            <button
              onClick={() => {
                setAddPopup(true);
                setType("add");
              }}
              className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn "
            >
              {" "}
              + Add New
            </button>
          )}
        </div>
      </div>
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={owners}
        show={true}
      />
      {addPopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-jb">
              <p className="f4 text-start  fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                {type == "add" ? "Add" : "Edit"}
              </p>
              <CloseSharpIcon
                onClick={() => {
                  setAddPopup(false);
                  setNames("");
                  setPolicy("");
                  setErrors("");
                }}
                className="pointer"
              />
            </div>
            <div className="d-flex ac-js mt-3">
              <div className="w-100">
                <div className="d-flex ac-jb mb-3">
                  <p className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 ">
                    Term & Coditions
                  </p>
                </div>
                {type == "add" && (
                  <div>
                    <div>
                      <div className="d-flex ae-jb input-border p-1">
                        <textarea
                          style={{ maxHeight: "80px" }}
                          // maxLength={250}
                          value={policy}
                          onChange={(e) => {
                            const sanitizedValue = e.target.value.replace(
                              /,/g,
                              ""
                            );
                            setPolicy(sanitizedValue);
                          }}
                          placeholder="Write Here...."
                          // onKeyPress={handleKeyPress}
                          className="border-0 mb-3 w-80"
                        />
                        <button
                          onClick={handleKeyPress}
                          className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 p-1"
                          style={{ minWidth: "100px" }}
                        >
                          Add
                        </button>
                      </div>
                      {errors && (
                        <p className="err text-start">
                          Please add at least one tagline.
                        </p>
                      )}
                    </div>
                    <div>
                      {names?.length > 0 ? (
                        <ul
                          className="input-border overflow-scroll mt-2"
                          style={{ minHeight: "50px", maxHeight: "200px" }}
                        >
                          {names?.map((name, index) => (
                            <li key={index} className="d-flex as-js gap-3 mt-2">
                              <img
                                src={arrow_icon}
                                className="bullet-btn"
                                alt=""
                              />
                              <p className="f2 fs-sm-10 fs-md-14 fs-lg-15 fs-xl-14 fs-xxl-16 w-80 text-start">
                                {name}
                              </p>
                              <img
                                src={delete_icon}
                                className="delete-btn"
                                onClick={() => handleDelete(index)} // ✅ pass index, not name
                                alt="delete"
                              />
                            </li>
                          ))}
                        </ul>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                )}
                {type == "edit" && (
                  <input
                    type="url"
                    value={tagLine}
                    onChange={(e) => {
                      const sanitizedValue = e.target.value.replace(/,/g, "");
                      setTagLine(sanitizedValue);
                    }}
                    placeholder="Tag Lines"
                    className="input-box"
                  />
                )}
              </div>
            </div>

            <div className="d-flex ac-je px-2 mt-4">
              <button
                onClick={() => {
                  handleSubmit();
                  // logout();
                }}
                className="submit-btn f2 w-20 p-2 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15"
              >
                {/* {loading ? "Loading..." : "Confirm"} */} Submit
              </button>
            </div>
          </div>
        </div>
      )}
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={handleDeleteList} className="add-btn w-40">
                Yes
              </button>
              <button
                onClick={() => {
                  setPopup(false);
                  // logout();
                }}
                className="back-btn f2 w-40"
              >
                {/* {loading ? "Loading..." : "Confirm"} */}No
              </button>
            </div>
          </div>
        </div>
      )}
      {loading && <Loader />}
    </div>
  );
};
export default TermsAndCondition;
